
import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const NotificationComponent = ({ notification, onClose }) => {
  useEffect(() => {
    if (notification) {
      // Auto-close notification after 5 seconds
      const timer = setTimeout(() => {
        onClose();
      }, 5000);
      
      return () => clearTimeout(timer);
    }
  }, [notification, onClose]);
  
  return (
    <AnimatePresence>
      {notification && (
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -50 }}
          className="fixed top-4 right-4 z-50 bg-white rounded-lg shadow-lg p-4 max-w-sm"
        >
          <div className="flex justify-between">
            <h3 className="font-bold text-lg">{notification.title}</h3>
            <button 
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
            >
              &times;
            </button>
          </div>
          <p className="mt-2">{notification.body}</p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default NotificationComponent;